import { useQuery } from '@gogame/query';

import { loadDrillTo } from '../sources/DataTable';
import { drillTo } from './queryKeyFactory';

export const useLoadDrillTo = (params) => {
  return useQuery(
    drillTo(params),
    (_, { signal }) => loadDrillTo(params, { signal }),
    {
      initialData: [],
    }
  );
};
